import * as React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './page/Home';
import Sponsorship from './page/Sponsorship';
import Volunteering from './page/Volunteering';
import WhatWeDo from './page/WhatWeDo';
import Blog from './page/Blog';
import Header from './components/Header';
import Footer from './components/Footer';
import * as ReactGA from 'react-ga';
class App extends React.Component {
  public render() {
    return (
      <div>
        <Header />
        <Router>
          <Switch>
            <Route
              path="/"
              exact={true}
              render={routeProps => {
                ReactGA.pageview('Home');
                return <Home />;
              }}
            />
            <Route
              path="/Sponsorship"
              exact={true}
              render={routeProps => {
                ReactGA.pageview('Sponsorship');
                return (
                  <Sponsorship />
                );
              }}
            />
            <Route
              path="/Blog"
              exact={true}
              render={routeProps => {
                ReactGA.pageview('Blog');
                return (
                  <Blog />
                );
              }}
            />
            <Route
              path="/WhatWeDo"
              exact={true}
              render={routeProps => {
                ReactGA.pageview('WhatWeDo');
                return (
                  <WhatWeDo />
                );
              }}
            />
            <Route
              path="/Volunteering"
              exact={true}
              render={routeProps => {
                ReactGA.pageview('Volunteering');
                return (
                  <Volunteering />
                );
              }}
            />
            <Route
              path="/Contact"
              exact={true}
              render={routeProps => {
                ReactGA.pageview('Contact');
                return (
                  <Home />
                );
              }}
            />
          </Switch>
        </Router>
        <Footer />
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx